import ActionType from '../actions/ActionType'
export default (state = { }, action) => {
    switch (action.type) {
        case ActionType.VOICE.GET_TOKEN_SUCCESS:           
            return {
                ...state,         
                token: action.payload && action.payload.twilio_token,
            }
        default:
            return state
    }
}